<template>
  <v-card class="card_setting">
    <v-card>
      <v-card-title>
        <v-avatar tile size="36" class="mr-4">
          <v-img :src="require('@/assets/icon/category.svg')"></v-img>
        </v-avatar>
        <h1>หมวดหมู่</h1>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา"
          single-line
          hide-details
          clearable
          solo
          dense
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="master_data"
        :search="search"
        id="table-text"
        class="elevation-1"
      >
        <template v-slot:top style="font-size:30px;">
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  class="mb-2 bg_btn_gradient"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-plus-circle</v-icon>
                  <span class="text_body_6 mt-1">เพิ่มหมวดหมู่</span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text_title_2">{{ formTitle }}</span>
                </v-card-title>
                <v-form ref="form" @submit.prevent="save">
                  <v-card-text class="py-0">
                    <v-container>
                      <v-row>
                        <v-col class="py-0">
                          <v-text-field
                            v-model="category"
                            dense
                            outlined
                            label="ชื่อหมวดหมู่"
                            :rules="rule_empty"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      <h4>ยกเลิก</h4>
                    </v-btn>
                    <v-btn color="blue darken-1" text type="submit">
                      <h4>บันทึก</h4>
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }"
          >{{ master_data.indexOf(item) + 1 }}.</template
        >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data></template>
      </v-data-table>
    </v-card>
  </v-card>
</template>

<script>
import { isEmptyTextField } from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      category: null,
      rule_empty: isEmptyTextField,
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      api_url: "api/v1/masterdata/category",
      dialog: false,
      search: "",
      headers: [
        {
          text: "ลำดับ",

          sortable: false,
          value: "no",
          width: "10%",
        },

        {
          text: "ชื่อหมวดหมู่",
          value: "categoryName",
          sortable: false,
          width: "80%",
        },

        { text: "จัดการ", value: "actions", sortable: false, width: "10%" },
      ],

      editedIndex: -1,

      master_data: [],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่มหมวดหมู่" : "แก้ไขหมวดหมู่";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    const module_name = "permission_setting";
    const func_name = "category";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        this.initialMethod();
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },

  methods: {
    initialMethod() {
      this.getMasterData();
    },
    getMasterData() {
      this.axios
        .get(process.env.VUE_APP_API + this.api_url, this.header_token)
        .then((res) => {
          this.master_data = res.data;
        });
    },
    post() {
      var data = {
        categoryName: this.category,
      };

      this.axios
        .post(process.env.VUE_APP_API + this.api_url, data, this.header_token)
        .then((res) => {
          if (res.data.message == "create success") {
            this.$swal.fire({
              icon: "success",
              title: "สร้างหมวเหมู่ใหม่สำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    put() {
      var id = this.master_data[this.editedIndex].categoryId;
      var data = {
        categoryName: this.category,
      };

      this.axios
        .put(
          process.env.VUE_APP_API + this.api_url + "/" + id,
          data,
          this.header_token
        )
        .then((res) => {
          if (res.data.message == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขหมวดหมู่สำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getMasterData();
          }
        });
    },
    deleteItem(item) {
      var id = item.categoryId;
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value == true) {
            this.axios
              .delete(
                process.env.VUE_APP_API + this.api_url + "/" + id,
                this.header_token
              )
              .then((res) => {
                if (res.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบรายการสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getMasterData();
                }
              });
          }
        });
    },

    editItem(item) {
      this.category = item.categoryName;
      this.editedIndex = this.master_data.indexOf(item);
      this.dialog = true;
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.$refs.form.validate()) {
          this.put();
          this.close();
        }
      } else {
        if (this.$refs.form.validate()) {
          this.post();
          this.close();
        }
      }
    },
  },
};
</script>
